import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import React, { useState } from 'react';

const ELLIPSIZE_PARAM = 140;

export function ellipsise(arg: string, nonEllipsisMaxLength = ELLIPSIZE_PARAM) {
  if (arg.length > nonEllipsisMaxLength) {
    return arg.substring(0, nonEllipsisMaxLength) + '...';
  }
  return arg;
}

type CollapsableTextProps = {
  text: string;
  nonEllipsisMaxLength?: number;
};

export const CollapsibleText = ({
  text,
  nonEllipsisMaxLength = ELLIPSIZE_PARAM,
}: CollapsableTextProps) => {
  const [open, setOpen] = useState(false);

  const onChange = (event: React.SyntheticEvent, expanded: boolean) => {
    setOpen(expanded);
  };

  const textAsString = text || '';
  const ellipsizedString = ellipsise(textAsString, nonEllipsisMaxLength);
  if (ellipsizedString === textAsString) {
    return <>{textAsString}</>;
  }

  return (
    <Accordion
      slotProps={{ transition: { unmountOnExit: true } }}
      onChange={onChange}
      sx={{
        boxShadow: 'none',
        padding: 0,
        margin: 0,
        width: '99%',
        background: 'rgba(0, 0, 0, 0)',
      }}
    >
      <AccordionSummary sx={{ padding: 0, margin: '0px !important' }} expandIcon={<ExpandMore />}>
        <Typography variant="body2">
          {' '}
          {open ? textAsString : ellipsise(textAsString, nonEllipsisMaxLength)}
        </Typography>
      </AccordionSummary>
    </Accordion>
  );
};
